import { BaseModel } from './base-model';
import { ConnectedUserModel } from './connected-user-model';

export class AlertCommentBaseModel extends BaseModel {
  comment: string;
  user: ConnectedUserModel;
  actionDate: Date;
}
